import { DataTable } from "@/components/data-table/data-table";
import { TeamCreditsHistoryDTO } from "@shaarp/common";
import { dataTableTeamCreditsHistoryColumns } from "./data-table-team-credits-history-columns";

export default function DataTableTeamCreditsHistory({
  creditsHistory,
  isLoading = false,
  onRemove,
}: {
  creditsHistory: TeamCreditsHistoryDTO[];
  isLoading?: boolean;
  onRemove?: (transaction: TeamCreditsHistoryDTO) => void;
}) {
  return (
    <DataTable
      data={creditsHistory}
      isLoading={isLoading}
      sortingState={[{ id: "Date", desc: true }]}
      columns={dataTableTeamCreditsHistoryColumns(onRemove)}
      pagination={true}
      pageSize={10}
      showLinesPerPage={false}
      showFilter={false}
      showTotalCounter={false}
    />
  );
}
